import React, { Component } from "react";

class Avcc extends Component {
    render() {
        return (
            <div className="centercontent footermargin">
                <h1>Arduino Controllers</h1>

                <div className="descarea">
                    <div className="descbox">
                        <p>
                            I'm practicing Arduino controllers with a project I'm doing with a friend. The idea is to
                            play music and control lights with body gestures. Here are some demo videos and explanations.
                        </p>
                    </div>

                    <img id="img" src="..\imgs\avatar_yellow_portrait_small.jpg" alt="avatar icon"/>
                </div>

                <div className="tape autotape">
                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="../videos/visualizer-video.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>

                    <div className="tapeexhibit">
                        <video autoPlay muted loop controls>
                            <source src="../videos/midicontrol-video.mp4" type="video/mp4"></source>
                            Demo video can not be played.
                        </video>
                    </div>
                </div>

                <div className="tape projecttape">
                    <div className="page" style={{backgroundImage: "url('../imgs/projects/avcc.jpg')", backgroundSize: "cover"}}>
                        <h2><span>Goal and Methods</span></h2>
                        <h4>
                            The goal is to play musical and visual effects with body movements. We use Arduino Nano 33 IoT boards because
                            of their convenient size and on-board sensors. We can use them to track movement changes and orientation wirelessly
                            using Wi-fi.<br></br><br></br>

                            We use Wekinator to detect gestures and send OSC data accordingly. This OSC data is received by a custom Python
                            socket server that can send MIDI signals into Ableton, where we can play music or control lights as seen in the
                            demo video above.
                        </h4>
                    </div>

                    <div className="page" style={{backgroundImage: "url('../imgs/projects/DeepDiveIntoJavaCode_U2_blur.jpg')", backgroundSize: "cover", backgroundPosition: "0 0"}}>
                        <h2><span>What we've done</span></h2>
                        <h4>
                            We have made demos of most features that we want to implement individually. Now the task is to combine everything into a
                            easy to use package that works with multiple boards.<br></br><br></br>

                            Currently I'm working on improving the Python socket server so that a user can easily connect multiple Arduino boards
                            to the system and decide how their data should be interpreted using a GUI. The project should see significant progress
                            during 2023.
                        </h4>
                    </div>
                </div>
            </div>
        );
    }
}

export default Avcc;